import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ImageWithFallback2 from 'components/desktop/_general/Image/ImageWithFallback2';
import 'components/desktop/_general/PictureBig/PictureBig.scss';

interface IProps {
	path: string;
	round?: boolean;
}

const PictureBig = (props: IProps) => {
	if (props.path) {
		return (
			<ImageWithFallback2
				alt="thumbnail"
				className="img-thumbnail img-thumbnail-custom"
				style={props.round ? { borderRadius: '50%' } : {}}
				src={props.path}
				placeholderStyle={{
					borderRadius: props.round ? '50%' : undefined,
					aspectRatio: '1 / 1',
					width: '100%',
					backgroundColor: 'grey',
				}}
				iconSize="5x"
			/>
		);
	} else {
		return (
			<div className="img-thumbnail img-thumbnail-custom">
				<div
					className="picture-big-placeholder d-flex justify-content-center align-items-center"
					style={props.round ? { borderRadius: '50%' } : {}}
				>
					<FontAwesomeIcon size="5x" icon={faCamera} style={{ color: 'white' }} />
				</div>
			</div>
		);
	}
};

export default PictureBig;
